import React, { useState, useEffect } from "react";
import "./internshipcontrols.css";

const InternshipAssignmentForm = () => {
  const [mode, setMode] = useState("add");
  const [domains, setDomains] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [config, setConfig] = useState(null);
  const [selectedAssignmentId, setSelectedAssignmentId] = useState("");

  const [oldImages, setOldImages] = useState(["", "", "", ""]);
  const [oldVideo, setOldVideo] = useState("");
  const [selectedDomain, setSelectedDomain] = useState("");


  const [formData, setFormData] = useState({
    domain: "",
    question_name: "",
    question: "",
    images: [null, null, null, null],
    video: null,
    show_upto: "",
  });

  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.GET_INTERNSHIP_DOMAINS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success)
          setDomains(data.domains.map((d) => d.internship_domain_name));
      });
  }, [config]);

useEffect(() => {
  if (!config || mode !== "update" || !selectedDomain) return;

  fetch(`${config.BASE_URL}${config.FETCH_ASSIGNMENTS_BY_DOMAIN}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ domain: selectedDomain }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) setAssignments(data.assignments);
      else setAssignments([]);
      setSelectedAssignmentId(""); 
    })
    .catch(() => setAssignments([]));
}, [config, mode, selectedDomain]);


useEffect(() => {
  if (!selectedAssignmentId) return;

  const selected = assignments.find(
    (a) => a.assignment_id === selectedAssignmentId
  );
  if (!selected) return;

  setFormData({
    domain: selected.domain, 
    question_name: selected.question_name,
    question: selected.question,
    images: [selected.image1, selected.image2, selected.image3, selected.image4],
    video: selected.video,
    show_upto: selected.show_upto,
  });

  setOldImages([selected.image1, selected.image2, selected.image3, selected.image4]);
  setOldVideo(selected.video);
}, [selectedAssignmentId, assignments]);


  useEffect(() => {
    if (!selectedAssignmentId) return;

    const selected = assignments.find(
      (a) => a.assignment_id === selectedAssignmentId
    );
    if (!selected) return;

    setFormData({
      domain: selected.domain,
      question_name: selected.question_name,
      question: selected.question,
      images: [
        selected.image1,
        selected.image2,
        selected.image3,
        selected.image4,
      ],
      video: selected.video,
      show_upto: selected.show_upto,
    });

    // Store old file names
    setOldImages([
      selected.image1,
      selected.image2,
      selected.image3,
      selected.image4,
    ]);

    setOldVideo(selected.video);
  }, [selectedAssignmentId, assignments]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e, index = null) => {
    const { name, files } = e.target;

    if (name === "images") {
      const newImages = [...formData.images];
      newImages[index] = files[0] || null;
      setFormData((prev) => ({ ...prev, images: newImages }));
    }

    if (name === "video") {
      setFormData((prev) => ({ ...prev, video: files[0] || null }));
    }
  };

  const removeImage = (idx) => {
    const newImages = [...formData.images];
    newImages[idx] = null;
    setFormData((prev) => ({ ...prev, images: newImages }));
  };

  const removeVideo = () =>
    setFormData((prev) => ({
      ...prev,
      video: null,
    }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!config) return;

    const url =
      mode === "add"
        ? `${config.BASE_URL}${config.ADD_ASSIGNMENT}`
        : `${config.BASE_URL}${config.UPDATE_ASSIGNMENT}`;

    const data = new FormData();

    if (mode === "update") {
      data.append("assignment_id", selectedAssignmentId);
    }

    data.append("domain", formData.domain);
    data.append("question_name", formData.question_name);
    data.append("question", formData.question);
    data.append("show_upto", formData.show_upto);

    // ALWAYS send old images
    oldImages.forEach((img, i) => {
      data.append(`old_image${i + 1}`, img ?? "");
    });

    // ALWAYS send old video
    data.append("old_video", oldVideo ?? "");

    // Add new uploaded images
    formData.images.forEach((img, idx) => {
      if (img instanceof File) {
        data.append(`image${idx + 1}`, img);
      }
    });

    if (formData.video instanceof File) {
      data.append("video", formData.video);
    }

    const res = await fetch(url, { method: "POST", body: data });
    const result = await res.json();
    alert(result.message);
  };

return (
  <div className="assignment-form">
    {/* Mode Switch */}
    <div>
      <button onClick={() => setMode("add")}>Add</button>
      <button onClick={() => setMode("update")}>Update</button>
    </div>

    {/* Update Mode: Select Domain and Assignment */}
    {mode === "update" && (
      <>
       <label>
        Domain:
        <select
          value={selectedDomain}
          onChange={(e) => setSelectedDomain(e.target.value)}
        >
          <option value="">Select Domain</option>
          {domains.map((d) => (
            <option key={d} value={d}>
              {d}
            </option>
          ))}
        </select>
      </label>


       <label>
  Assignment:
  <select
    value={selectedAssignmentId}
    onChange={(e) => setSelectedAssignmentId(e.target.value)}
    disabled={!selectedDomain} 
  >
    <option value="">Select Assignment</option>
    {assignments.map((a) => (
      <option key={a.assignment_id} value={a.assignment_id}>
        {a.question_name}
      </option>
    ))}
  </select>
</label>

      </>
    )}

    <form onSubmit={handleSubmit}>
      {/* Add Mode: Domain Field */}
      {mode === "add" && (
        <label>
          Domain:
          <select name="domain" value={formData.domain} onChange={handleChange}>
            <option value="">Select</option>
            {domains.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </label>
      )}

      <label>
        Question Name:
        <input
          type="text"
          name="question_name"
          value={formData.question_name}
          onChange={handleChange}
        />
      </label>

      <label>
        Question:
        <textarea
          name="question"
          value={formData.question}
          onChange={handleChange}
        ></textarea>
      </label>

      <label>
        Images:
        {formData.images.map((img, idx) => (
          <div key={idx}>
            {img && !(img instanceof File) && selectedAssignmentId && (
              <img
                src={`/Assignment_images/${selectedAssignmentId}/${img}`}
                width={120}
                alt=""
              />
            )}
            <input
              type="file"
              name="images"
              onChange={(e) => handleFileChange(e, idx)}
               accept=".jpg,.jpeg,.png,.webp,.gif"
            />
            {img && <button type="button" onClick={() => removeImage(idx)}>Remove</button>}
          </div>
        ))}
      </label>

      <label>
        Video:
        {formData.video && !(formData.video instanceof File) && (
          <video
            width={200}
            controls
            src={`/Assignment_images/${selectedAssignmentId}/${formData.video}`}
          ></video>
        )}
        <input
          type="file"
          name="video"
          accept="video/*"
          onChange={handleFileChange}
        />
        {formData.video && <button type="button" onClick={removeVideo}>Remove</button>}
      </label>

      <label>
        Show Upto:
        <input
          type="date"
          name="show_upto"
          value={formData.show_upto}
          onChange={handleChange}
        />
      </label>

      <button type="submit">
        {mode === "add" ? "Add Assignment" : "Update Assignment"}
      </button>
    </form>
  </div>
);

};

export default InternshipAssignmentForm;
